import type { Order, OrderItem } from "../shared/order-domain";

const DOWNLOADED_KEY = "xianyu_downloaded";
const DEMO_ALL_KEYS = [
  "demo/qj-file1.3mf",
  "demo/qj-file2.3mf",
  "demo/r114-t10.3mf",
  "demo/r133-t30.3mf",
  "demo/r134-t20.3mf",
  "demo/fenglen-hou.3mf",
];
const DEMO_UNDOWNLOADED = [
  "demo/r114-t10.3mf",
  "demo/r133-t30.3mf",
  "demo/qj-file2.3mf",
];

function downloadedKeys(): Set<string> {
  try {
    const parsed = JSON.parse(localStorage.getItem(DOWNLOADED_KEY) || "[]") as unknown;
    return new Set(Array.isArray(parsed) ? parsed.filter((key): key is string => typeof key === "string") : []);
  } catch {
    return new Set();
  }
}

export function markDownloadedLocally(fileKey: string): void {
  const keys = downloadedKeys();
  keys.add(fileKey);
  localStorage.setItem(DOWNLOADED_KEY, JSON.stringify([...keys]));
}

export function isFileDownloaded(item: Pick<OrderItem, "file_key" | "downloaded_at">): boolean {
  return Boolean(
    item.file_key && (item.downloaded_at || downloadedKeys().has(item.file_key)),
  );
}

export function isItemAcknowledged(
  item: Pick<OrderItem, "file_key" | "downloaded_at" | "acknowledged_at">,
): boolean {
  return isFileDownloaded(item) || Boolean(item.acknowledged_at);
}

export function unacknowledgedItems(orders: readonly Order[]): OrderItem[] {
  return orders
    .flatMap((order) => order.items)
    .filter((item) => Boolean(item.file_key) && !isItemAcknowledged(item));
}

export function initializeDemoDownloads(orders: readonly Order[]): void {
  if (localStorage.getItem(DOWNLOADED_KEY)) return;
  const hasDemoFiles = orders.some((order) =>
    order.items.some((item) => item.file_key?.startsWith("demo/")),
  );
  if (!hasDemoFiles) return;
  localStorage.setItem(
    DOWNLOADED_KEY,
    JSON.stringify(DEMO_ALL_KEYS.filter((key) => !DEMO_UNDOWNLOADED.includes(key))),
  );
}
